import { registerHandlers } from '../sagas/TaskManager';

import IntegrationWatchers from './integrations/watchers';
import UseCaseWatchers from './useCases/watchers';

const allActions = UseCaseWatchers.concat(IntegrationWatchers);

// eslint-disable-next-line require-yield
export default function* mediatorSaga() {
  registerHandlers(allActions);
}
